/**
 * LandingSkeleton - Loading placeholder for Landing Page
 * Shows a skeleton that matches the Landing Page layout structure
 */
export function LandingSkeleton() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 animate-pulse">
      {/* Header Skeleton */}
      <header className="h-16 border-b border-gray-200 dark:border-gray-800">
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between">
          <div className="h-8 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="hidden md:flex space-x-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
            ))}
          </div>
          <div className="h-10 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
      </header>

      {/* Hero Skeleton */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <div className="h-12 w-3/4 mx-auto bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-6 w-2/3 mx-auto bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-6 w-1/2 mx-auto bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="flex justify-center gap-4 pt-4">
            <div className="h-12 w-36 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-12 w-36 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        </div>
      </section>

      {/* Features Grid Skeleton */}
      <section className="py-16 px-6 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="h-8 w-48 mx-auto bg-gray-200 dark:bg-gray-700 rounded mb-12" />
          <div className="grid md:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="p-6 bg-white dark:bg-gray-900 rounded-lg shadow">
                <div className="h-12 w-12 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
                <div className="h-6 w-3/4 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
                <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded" />
                <div className="h-4 w-2/3 bg-gray-200 dark:bg-gray-700 rounded mt-2" />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
